//==========================================================================
// top.js
//==========================================================================

function initKvSlider() {
  const $slider = $('.js-kv_slider');

  function replaceClonedHeadings(slick) {
    $(slick.$slider)
      .find('.slick-cloned h1')
      .each(function () {
        const $h1 = $(this);
        const $div = $('<div>')
          .addClass($h1.attr('class')) 
          .html($h1.html());
        $h1.replaceWith($div);
      });
  }

  $slider.on('init reInit afterChange', function (event, slick) {
    replaceClonedHeadings(slick);
  });

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000, 
    speed: 450,               
    cssEase: 'ease-out',
    swipeToSlide: true,
    waitForAnimate: false,
    touchThreshold: 8,
    variableWidth: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    swipe: true,
    touchMove: true,
    draggable: true,
  });
}


function initRankingSlider() {
  const slickOptions = {
    slidesToShow: 1.85,
    slidesToScroll: 1,
    centerMode: false,
    // variableWidth: true,
    dots: true,
    arrows: false,
    infinite: false,
  };

  function checkSlider() {
    $('.js-ranking_slider').each(function () {
      const $slider = $(this);

      if ($(window).width() <= 767) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(slickOptions);
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }

  checkSlider();
  $(window).on('resize orientationchange', checkSlider);
}

function initVoiceSlider() {
  const slickOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    // variableWidth: true,
    dots: true,
    arrows: false,
    infinite: false
  };

  function checkSlider() {
    $('.js-voice_slider').each(function () {
      const $slider = $(this);

      if ($(window).width() <= 767) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(slickOptions);
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }

  checkSlider();
  $(window).on('resize orientationchange', checkSlider);
}

//------------------------------
$(function () {
  initKvSlider();
  initRankingSlider();
  initVoiceSlider();
});

